'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Domů', href: '/homepage' },
    { label: 'Jak pracujeme', href: '/how-we-work' },
    { label: 'Online diagnóza', href: '/online-initial-diagnosis' },
    { label: 'Finanční plán', href: '/financial-plan' },
  ];

  const moreMenuItems = [
    { label: 'První schůzka', href: '/first-meeting-analysis' },
    { label: 'Dlouhodobé partnerství', href: '/service-long-term-partnership' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-card">
      <div className="container mx-auto">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center space-x-2 hover:opacity-80 transition-smooth">
            <img
              src="/assets/images/logo_-_transpar-1777541518906.png"
              alt="Co-Work logo"
              className="h-10 lg:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems?.map((item) => (
              <Link
                key={item?.href}
                href={item?.href}
                className="px-4 py-2 text-sm font-medium text-text-primary hover:text-primary hover:bg-surface rounded-md transition-smooth"
              >
                {item?.label}
              </Link>
            ))}

            {/* More Dropdown */}
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-medium text-text-primary hover:text-primary hover:bg-surface rounded-md transition-smooth flex items-center space-x-1">
                <span>Více</span>
                <Icon name="ChevronDownIcon" size={16} className="text-current" />
              </button>
              <div className="absolute right-0 mt-2 w-56 bg-popover border border-border rounded-md shadow-elevated opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-smooth">
                {moreMenuItems?.map((item) => (
                  <Link
                    key={item?.href}
                    href={item?.href}
                    className="block px-4 py-3 text-sm text-popover-foreground hover:bg-surface transition-smooth first:rounded-t-md last:rounded-b-md"
                  >
                    {item?.label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center space-x-4 pr-4">
            <Link
              href="/online-initial-diagnosis"
              className="px-6 py-2.5 bg-cta text-cta-foreground font-semibold rounded-md hover:bg-cta-hover hover:shadow-hover hover:scale-102 transition-smooth"
            >
              Rezervovat schůzku
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-text-primary hover:text-primary hover:bg-surface rounded-md transition-smooth"
            aria-label="Toggle menu"
          >
            <Icon
              name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24}
              className="text-current"
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-card">
            <nav className="py-4 space-y-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.href}
                  href={item?.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-3 text-sm font-medium text-text-primary hover:text-primary hover:bg-surface transition-smooth"
                >
                  {item?.label}
                </Link>
              ))}
              <div className="border-t border-border my-2"></div>
              {moreMenuItems?.map((item) => (
                <Link
                  key={item?.href}
                  href={item?.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-3 text-sm font-medium text-text-secondary hover:text-primary hover:bg-surface transition-smooth"
                >
                  {item?.label}
                </Link>
              ))}
              <div className="px-4 pt-4">
                <Link
                  href="/online-initial-diagnosis"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full px-6 py-3 bg-cta text-cta-foreground text-center font-semibold rounded-md hover:bg-cta-hover transition-smooth"
                >
                  Rezervovat schůzku
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;